// extracted by mini-css-extract-plugin
export default {"row":"TicketRow_row__V0S8r","header":"TicketRow_header__y-CJS","subject":"TicketRow_subject__2YQOi","date":"TicketRow_date__fXSx6"};